(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ws_manu-section"] && !Shopify.designMode) return;
  try {
    
const menuItems = document.querySelectorAll('.ws_menu-item');
menuItems.forEach(item => {
  item.addEventListener('click', () => {
    menuItems.forEach(item => {
      item.classList.remove('ws_active-link');
    });
    item.classList.add('ws_active-link');
  });
});

  } catch(e) { console.error(e); }
})();
})();
